module.exports = __webpack_public_path__ + "static/img/map__mylocation__pinicon.0eb610c4.svg";